// extracted by mini-css-extract-plugin
module.exports = {"title":"e_9E","container":"e_-E","right":"e_aF","image":"e_bF","scoreLine":"e_cF","scoreRing":"e_dF","badge":"e_eF","badgeImage":"e_fF","badgeRing":"e_gF","large":"e_hF"};